/** @format */

import {
	GetMembersDistributionDistributionControllerResponse,
	ProductTypeRequest,
	SelectionModeType,
} from "_clients/BFFClient.generated"

export type CreditDispatchTableProps = {
	data: GetMembersDistributionDistributionControllerResponse
	pageNumber: number
	networkId: string
	marketId: number
	productType: ProductTypeRequest
	onPageChange: (pageNumber: number) => void
	isLoading: boolean
	contractId: number
	setDistributionChangeInProgress: (value: DistributionChangeType) => void
}

export enum DistributionChangeType {
	ALLOCATED_BOOST,
	DISTRIBUTION_MODE,
	ALL
}

export enum UpdateInProgressEnum {
	None = 0,
	UpdateRepartitionInProgress = 1 << 0, // 0001
	UpdateAutoModeInProgress = 1 << 1, // 0010
}

export const TIMEOUT_DURATION = 3000;

type BaseUpdate = {
    rcuId: string,
    networkId: string,
    marketId: number,
    productType: ProductTypeRequest
};

export type AutoModeUpdate = {
    [key: string]: BaseUpdate & {
        selectionModeType: SelectionModeType
    };
};

export type DistributionUpdate = {
    [key: string]: BaseUpdate & {
        value: number
    };
};